export const displayMilitaryTime = timestamp => {
  if (isNaN(timestamp)) {
    return null;
  }
  const timeStampInt = Number(timestamp);
  const isValidTimestamp = new Date(timeStampInt).getTime() > 0;
  let hours = new Date(timeStampInt).getHours();
  let minutes = new Date(timeStampInt).getMinutes();
  if (hours < 10) hours = `0${hours}`;
  if (minutes < 10) minutes = `0${minutes}`;
  return isValidTimestamp ? `${hours}:${minutes}` : null;
};

export const convertUnixTimestamp = (timestamp, displayHourMinutes) => {
  const date = new Date(timestamp);
  let currentTime = new Date(timestamp).toLocaleTimeString('en-US');
  if (displayHourMinutes) {
    currentTime = new Date(timestamp)
      .toLocaleTimeString()
      .replace(/:\d{2}\s/, ' ');
  }
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month}/${day}/${year} at ${currentTime}`;
};

/**
 * Helper function for formatting react-timeago output per MC-21072
 * See https://github.com/nmn/react-timeago#formatter-optional for documentation
 * @param {String} value - an integer value, already rounded off
 * @param {String} unit - a string representing the unit in english
 * @param {String} suffix - one of `ago` or `from now`
 */

export const reactTimeAgoFormatter = (value, unit, suffix) => {
  let displayUnit = unit;
  if (unit === 'minute') {
    displayUnit = 'min';
  } else if (unit === 'second') {
    displayUnit = 'sec';
  } else if (value > 1) {
    displayUnit = `${unit}s`;
  }
  return `${value} ${displayUnit} ${suffix}`;
};

export function formatDate(timestamp) {
  let date;
  if (timestamp) {
    date = new Date(timestamp);
  } else {
    date = new Date();
  }
  const dd = date.getDate();
  const mm = date.getMonth() + 1;
  const yy = date.getFullYear();
  return `${mm}/${dd}/${yy}`;
}
